import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derivatAutoCreateVirtel_kadica, derivatAutoCreateVirtel_kadica_priprema_ulaza, derivatPoluproizvod_kadica_naziv } from "./ter-derivat-lib-terkk-kadica";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*

KADICA

- sirina se ubacuje rucno
- duzina kadice se izracunava i vezana je za sirinu modula
formule su u fajlu 11 EXCEL - KADIE.xlsx 

Ukoliko je profil 50 onda se unutrasnje sirine modula oduzima 2*zazor, Ukoliko je profil 70 onda se unutrasnje sirine modula oduzima (2*15)+(2*zazor)

....duzina ukoliko je profil 50 onda...??

koristimo msirinaunutrasnja u toj fomuli

i povezujemo sa modul konstrukcija profila poljem..

to su parasmtrei za tu formulu



- tip da nema nista kao default
- profil se nasledjuje od komore.
- odvodna iam da se bira samo 1 i 3/4
- ** bilo bi dobro da i automtski izracunata polja mogu da se ponova izracunaju..
u interfejsu takodje da se nekom kvacicom aktivira polje da ne bude read-only da moze rucno da se unosi.

*/


export const draftel_codecs_pack_terkk$kadica = {};
export const draftel_codecs_pack_terkk$kadica_v2 = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$kadica.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$kadica',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    // _protobomp: protobomp_manipulator.init(),
    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$kadica_v2"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    tip: null,
    duzina: null,
    sirina: null,
    odvodkondenzata: null,
    kolicina: 1,
    cnccrtez: null, // NOVO

    // materijali
    kadica_materijal_lim: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$kadica_v2.default_preset_state = () => {
  return {
    ...draftel_codecs_pack_terkk$kadica.default_preset_state(),
    _draftelschemakey: 'terkk$kadica_v2',
    // _draftelschemakey_prev_version: 'terkk$kadica', // TODO ovo treba resiti u multiadapteru
  };
};


draftel_codecs_pack_terkk$kadica.default_pods_input_state = () => {
  /*
  return {
    msirinaunutrasnja: null,
    vrstaprofila: null,
    siframodula: null,
  };
  */
  return default_pods_input_state_smart_get('terkk$kadica');
};


// 
draftel_codecs_pack_terkk$kadica.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "msirinaunutrasnja",
  // "vrstaprofila",
  // "siframodula",
  ...Object.keys(draftel_codecs_pack_terkk$kadica.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$kadica.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$kadica.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$kadica');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = formState;
  const kadicaNaziv = derivatPoluproizvod_kadica_naziv(p.tip, p.duzina, p.sirina, p.odvodkondenzata);
  state.naziv = kadicaNaziv;
  const state2 = {
    virtelschemakey: 'terkk$kadica',
    ...state,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    multitranslator_lang: "terkk$kadica/SKLOP_KADICA",
    ..._getParamsFromLib("terkk$kadica") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$kadica.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$kadica');
  const virtel = draftel_codecs_pack_terkk$kadica.drafel_to_virtel(draftel);

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // KORAK poluproizvod level 3 virtel
  // graphlevel: 3,
  // const graphlevel = 3;
  const local_graphlevel = 1;
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
  _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);

  // KORAK pripreme derivata za
  let pods_input_za_derivate = derivatAutoCreateVirtel_kadica_priprema_ulaza(draftel); // ??? 
  let _derivati = derivatAutoCreateVirtel_kadica(pods_input_za_derivate);
  console.log('_derivati kadica');
  console.log(_derivati);

  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$kadica.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  let state = {
    ...draftel_codecs_pack_terkk$kadica.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$kadica.keys_for_direct_cloning)
  };
  //
  return state;
};

